module.exports = __webpack_public_path__ + "static/media/certificate.9bbb1c7b.jpg";